module.exports = __webpack_public_path__ + "img/video_consultation.ab97779a.png";